import { attack, finishMovementOfUnit, moveUnit, selectAttacker, selectDefender, selectUnitForActivation, selectUnitForMovement, setStateName, stayAtOriginalPosition, } from '../gameStateMachine/request/index.js';
import { isSamePosition } from '@wareena/game-algorithms';
import getDiceRollResults from '../gameStateMachine/helpers/battle/getDiceRollResults.js';
const createAgentInterpreter = (agent, machine, rules) => {
    const createRequestsForActivation = (orders, agentUserId) => {
        const requests = [];
        orders.forEach((order) => {
            requests.push(selectUnitForActivation(order.agentUnit.id, agentUserId));
        });
        requests.push(setStateName('selectingForMovement', agentUserId));
        return requests;
    };
    const createRequestsForMovement = (orders, agentUserId) => {
        const requests = [];
        orders.forEach((order) => {
            if (order.targetPosition && order.pathToTargetPosition?.length) {
                requests.push(selectUnitForMovement(order.agentUnit.id, agentUserId));
                order.pathToTargetPosition.forEach((position) => {
                    requests.push(moveUnit(order.agentUnit.id, position, agentUserId));
                });
                requests.push(finishMovementOfUnit(order.agentUnit.id, agentUserId));
            }
            else {
                requests.push(selectUnitForMovement(order.agentUnit.id, agentUserId));
                requests.push(stayAtOriginalPosition(order.agentUnit.id, agentUserId));
            }
        });
        return requests;
    };
    const simulateRequest = (request, state) => {
        const newState = machine.executeRequest(request, state);
        return { request, newState };
    };
    const cloneState = (state) => {
        return JSON.parse(JSON.stringify(state));
    };
    const createBattleRequestsFromOrder = (order, agentUserId, state) => {
        // ak mame ciel
        // a zaroven tento ciel stale existuje
        // a zaroven vieme nan zautocit
        //     tak nan zautocime
        // inak
        //     ak vieme utocit
        //     vyberieme si ciel
        //         zautocime
        // inak
        //     skusime inu jednotku a skontrolujeme po nej?
        const requests = [];
        // does agent unit still exists?
        const agentUnit = state.units.find((u) => u.id === order.agentUnit.id);
        if (!agentUnit) {
            return null;
        }
        let newState = cloneState(state);
        const allTargets = rules.getPossibleTargets(agentUnit, newState.units);
        if (allTargets.length === 0) {
            return null;
        }
        let targetEnemy = null;
        if (order.targetEnemy &&
            allTargets.find((t) => isSamePosition(t, order.targetEnemy.position))) {
            targetEnemy = newState.units.find((u) => u.id === order.targetEnemy?.id) ?? null;
        }
        if (!targetEnemy) {
            const positionOfTarget = allTargets[0];
            targetEnemy =
                newState.units.find((u) => isSamePosition(u.position, positionOfTarget)) ?? null;
        }
        if (targetEnemy) {
            let result = simulateRequest(selectAttacker(agentUnit.id, crypto.randomUUID(), agentUserId), newState);
            requests.push(result.request);
            newState = result.newState;
            result = simulateRequest(selectDefender(targetEnemy.id, agentUserId), newState);
            requests.push(result.request);
            newState = result.newState;
            const diceRollResults = getDiceRollResults(newState, rules);
            if (!diceRollResults) {
                return null;
            }
            result = simulateRequest(attack(agentUserId, diceRollResults), newState);
            requests.push(result.request);
            newState = result.newState;
        }
        return {
            requests,
            newState,
        };
    };
    const createRequestsForBattle = (orders, agentUserId, gameState, previousRequests) => {
        const requests = [];
        let simulatedState = cloneState(gameState);
        previousRequests.forEach((request) => {
            const result = simulateRequest(request, simulatedState);
            simulatedState = result.newState;
        });
        orders.forEach((order) => {
            const result = createBattleRequestsFromOrder(order, agentUserId, simulatedState);
            if (!result || !result?.requests?.length) {
                return;
            }
            simulatedState = result.newState;
            requests.push(...result.requests);
        });
        return requests;
    };
    return {
        makeMove: (gameState, agentUserId) => {
            const orders = agent.getOrders(gameState);
            if (!orders || orders.length === 0) {
                return [];
            }
            const requests = [
                ...createRequestsForActivation(orders, agentUserId),
                ...createRequestsForMovement(orders, agentUserId),
            ];
            const battleRequests = createRequestsForBattle(orders, agentUserId, gameState, requests);
            if (battleRequests.length) {
                requests.push(...battleRequests);
            }
            return requests;
        },
    };
};
export default createAgentInterpreter;
